// ported from https://github.com/react-bootstrap/react-bootstrap/blob/f11723114d532cfce840417834a73733a8436414/src/divWithClassName.tsx
import classNames from "./classnames";
export const divWithClass = (c) => (p) => {
    return <div {...p} class={classNames(p.class, c)}/>;
};
